import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFaq = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于妖精视频的常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-950 pr-4">
                  {item.question}
                </span>
                <i
                  className={`text-foreground-400 text-sm transition-transform duration-200 shrink-0 ${
                    openId === item.id ? "ri-subtract-line" : "ri-add-line"
                  }`}
                ></i>
              </button>
              {openId === item.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}